module.exports = __webpack_public_path__ + "img/stop.8bc1677f.svg";